import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { LandownerdetailService } from './landownerdetail.service';
import { global } from '../../shared/global';
import { LandOwnerRequest } from '../Models/landowner.model';
import { schoolfullregistrationrequestService } from '../School/schoolfullregistrationrequest/schoolfullregistrationrequest.service';
declare var $: any;

@Component({
  selector: 'app-landownerdetail',
  templateUrl: './landownerdetail.component.html',
  styleUrls: ['./landownerdetail.component.css']
})
export class LandownerdetailComponent implements OnInit {

  @ViewChild('ownerDetail') ownerDetail: NgForm;
  searchtext;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  dropDownData: any;
  years: any;
  data: LandOwnerRequest;
  submitted: boolean;
  HashCode: any;
  OwnerDetaillist: any;
  btnsubmittext = "Add";
  schoolname: any;
  
  constructor(private service: LandownerdetailService, private regservice: schoolfullregistrationrequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.HashCode = this.rout.snapshot.paramMap.get('ID');
      this.schoolname = "- (" + localStorage.getItem("SchoolName") + ")";
      if (this.HashCode.trim() == "") {
        this.router.navigate(['/registrationlist']);
        return;
      }
    } else {
      this.router.navigate(['/registrationlist']);
      return;
    }
    this.data = new LandOwnerRequest();
    this.GetOwnerDetailList();
  }

  GetOwnerDetailList() {
    const data = {
      HashCode: this.HashCode
    };
    this.service.getLandOwnerDetailList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.OwnerDetaillist = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.OwnerDetaillist = this.responseData.landOwnerDetailRequestList;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  onSubmit(data) {
    this.submitted = true;
    this.data.HashCode = this.HashCode;
    this.data.YearID = +localStorage.getItem("yearID");
    if (this.ownerDetail.valid) {
      this.spinner.show();
      this.service.saveLandOwnerDetail(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
            return
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.GetOwnerDetailList();
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }

  editLandOwnerDetail(HashCode) {
    this.spinner.show();
    const data = {
      HashCode: HashCode
    };
    this.service.getLandOwnerDetailByID(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.data = this.responseData;
          this.btnsubmittext = "Update";
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  deleteLandOwnerDetail(HashCode,ID) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode,
        DetID : ID
      }
      this.spinner.show();
      this.service.deleteLandOwnerDetail(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
            return
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.GetOwnerDetailList();
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }

  resetForm() {
    this.data.ID = 0;
    this.data.OwnerMailID = null;
    this.data.OwnerMobileNo = null;
    this.data.OwnerName = null;
    this.submitted = false;
    this.btnsubmittext = "Add";
  }

  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.OwnerDetaillist.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  Cancel() {
    this.router.navigate(['/registrationlist']);
  }
}
